<template>
    <div class="MhPdfViewer">
      <div class="btnPreDiv" :style="{display: _btnDisplay}">
        <el-button plain size="mini" v-show="showBtn" icon="el-icon-document"  @click="viewPdf">{{vText}}</el-button>
      </div>
      <el-dialog :title="title" :visible.sync="showPdfViewer" :close-on-click-modal="false"
                 :modal-append-to-body="false" width="80%" top="20px" fullscreen>
        <iframe :src="pdfUrl" frameborder="2" style="width: 100%; height: 100%"></iframe>
      </el-dialog>
      <el-dialog :title="title" :visible.sync="showXlsxViewer" :close-on-click-modal="false"
                 :modal-append-to-body="false" width="80%" top="20px" fullscreen>
        <mh-excel-viewer ref="mev" :sheets="xlsxSheets" :workBooks="xlsxWorksBooks" v-on:selectValChange="changeSelectVal($event)"></mh-excel-viewer>
        <template slot="title">
          <div class="titleDiv">
            {{excelSelectVal}}
          </div>
        </template>
      </el-dialog>
    </div>

</template>

<script>
import XLSX from 'xlsx'
import MhExcelViewer from '@/components/base/MhExcelViewer.vue'
export default {
  name: 'MhPdfViewer',
  props: ['rootDirCode', 'displayBtn', 'rootDirField', 'filePath', 'fileName', 'fileDisplayName', 'showBtn', 'vType', 'vText'],
  data () {
    return {
      showPdfViewer: false,
      showXlsxViewer: false,
      xlsxSheets: [],
      xlsxWorksBooks: {},
      onlyDownload: false,
      pdfUrl: '',
      excelSelectVal: '1',
      title: '',
      path: 'http://192.168.1.9:6070/mherp/'
    }
  },
  components: {
    MhExcelViewer
  },
  computed: {
    showFileName () {
      if ((this.fileDisplayName) && (this.fileDisplayName !== '')) {
        return this.fileDisplayName
      } else {
        return this.fileName
      }
    },
    _btnDisplay () {
      if ((!this.displayBtn) || (this.displayBtn === '')) {
        return 'block'
      } else {
        return this.displayBtn
      }
    }
  },
  methods: {
    changeSelectVal: function (val) {
      this.excelSelectVal = val
    },
    viewPdfInComponent: async function (pdfUrl) {
      const that = this
      const para = {
        url: pdfUrl,
        fileDisplayName: that.fileDisplayName
      }
      const stl = await that.$Any.getStaticRouterUrl('PDFVIEWER', that.fileName)
      para.id = 'PDFVIEWER'
      para.nbr = that.fileName
      para.lot = ''
      para.code = ''
      that.$Any.pushRouter(that.$router, stl, that.fileName, para)
    },
    viewXlsx: function (blobFile) {
      const that = this
      that.xlsxSheets = []
      that.xlsxWorksBooks = {}
      const reader = new FileReader()
      reader.onload = function (e) {
        const data = e.target.result
        const wb = XLSX.read(data, {
          type: 'binary',
          cellDates: true,
          cellText: false
        })
        for (const sheet in wb.Sheets) {
          const sheetArray = XLSX.utils.sheet_to_json(wb.Sheets[sheet], {
            defval: null,
            raw: true,
            dateNF: 'yyyy-MM-dd'
          })
          that.xlsxSheets.push(sheet)
          that.xlsxWorksBooks[sheet] = sheetArray
          that.showXlsxViewer = true
        }
      }
      reader.readAsBinaryString(blobFile)
    },
    viewXlsxMaps: function (excelMaps) {
      const that = this
      that.xlsxSheets = excelMaps.Sheets
      that.xlsxWorksBooks = excelMaps.Workbooks
      that.showXlsxViewer = true
    },
    checkFileType: function () {
      const that = this
      // const officeExtensions = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf']
      const officeExtensions = ['.doc', '.docx', '.ppt', '.pptx', '.pdf', '.xlsx', '.xls']
      const extension = that.fileName.toLowerCase().slice(that.fileName.lastIndexOf('.'))
      that.onlyDownload = !officeExtensions.includes(extension)
    },
    preExcelFile: async function (url, para) {
      const that = this
      const { data: res } = await this.$http.post(url, para)
      const flag = res.data.flag
      const msg = res.data.msg
      if (flag !== -1) {
        that.$alert(msg, this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm')
        })
      } else {
        const excelMaps = res.data.excelMaps
        that.viewXlsxMaps(excelMaps)
      }
    },
    viewPdf: async function () {
      const that = this
      const p = {
        rootDirCode: that.rootDirCode,
        rootDirField: that.rootDirField,
        filePath: that.filePath,
        fileName: that.fileName,
        reConvert: false
      }
      // const xlsReg = /\.xl(s[xmb]|t[xm]|am|s)$/g
      // const isXls = xlsReg.test(that.fileName)
      const isXls = false
      let url = '/users/openOfficeToPdf'
      that.checkFileType()
      // if ((that.fileName.toLowerCase().lastIndexOf('.pdf') > 0) || (that.vType === 'download') || (that.onlyDownload)) {
      //   url = '/edoc/responseEdocFile'
      // } else
      if ((isXls) && (that.vType === 'view')) {
        url = '/edoc/downloadExcelContent'
        that.preExcelFile(url, p)
      } else {
        url = '/edoc/responseEdocFile'
        that.$emit('updateUpDown', 'down', 0)
        that.$http.post(url, p, {
          responseType: 'blob',
          onDownloadProgress (progress) {
            if (progress.lengthComputable) {
              const val = (progress.loaded / progress.total * 100).toFixed(0) / 100
              that.$emit('updateUpDown', 'down', val)
              if (val >= 99.999) {
                that.$emit('updateUpDown', '', 0)
              }
            }
          }
        }).then((response) => {
          that.$emit('updateUpDown', '', 0)
          const content = response.data
          const blob = new Blob([content])
          const aLink = document.createElement('a')
          const url = URL.createObjectURL(blob)
          if ((that.vType === 'view') && (!that.onlyDownload)) {
            if (that.fileName.toLowerCase().lastIndexOf('.pdf') > 0) {
              that.pdfUrl = './static/pdf/web/viewer.html?file=' + encodeURIComponent(url)
              that.viewPdfInComponent(that.pdfUrl)
              that.title = that.showFileName
            } else {
              that.$http.post('/kkFile/fileUpload', p).then(() => {
                const fileType = that.fileName.split('.').slice(1).join('.')
                if (fileType === 'xls') {
                  that.fileName = that.fileName + 'x'
                }
                if (fileType === 'XLS') {
                  that.fileName = that.fileName + 'X'
                }
                const path = that.path + 'demo/' + that.fileName
                const path64 = btoa(path)
                that.pdfUrl = that.path + 'kkFile/onlinePreview?url=' + path64 + '&forceUpdatedCache=true'
                if (fileType === 'xls') {
                  that.pdfUrl = that.path + 'kkFile/onlinePreview?url=' + path64
                }
                that.viewPdfInComponent(that.pdfUrl)
                that.title = that.showFileName
              })
            }
          } else {
            if ('download' in aLink) {
              aLink.download = that.showFileName
              aLink.style.display = 'none'
              aLink.href = url
              document.body.appendChild(aLink)
              aLink.click()
              URL.revokeObjectURL(aLink.href)
              document.body.removeChild(aLink)
            } else {
              navigator.msSaveBlob(blob, that.showFileName)
            }
          }
        })
      }
      // const { data: res } = await this.$http.post(url, p)
      // const flag = res.data.flag
      // const msg = res.data.msg
      // if (flag !== -1) {
      //   that.$alert(msg, '提示', {
      //     confirmButtonText: '确定'
      //   })
      // } else {
      //   const base64Str = res.data.base64Str
      //   const aLink = document.createElement('a')
      //   const blob = that.$Any.base64ToBlob(base64Str)
      //   const url = URL.createObjectURL(blob)
      //   if ((that.vType === 'view') && (!that.onlyDownload)) {
      //     if (isXls) {
      //       const excelMaps = res.data.excelMaps
      //       // that.viewXlsx(blob)
      //       that.viewXlsxMaps(excelMaps)
      //     } else {
      //       that.pdfUrl = './static/pdf/web/viewer.html?file=' + encodeURIComponent(url)
      //       that.showPdfViewer = true
      //       that.title = that.showFileName
      //     }
      //   } else {
      //     if ('download' in aLink) {
      //       aLink.download = that.showFileName
      //       aLink.style.display = 'none'
      //       aLink.href = url
      //       document.body.appendChild(aLink)
      //       aLink.click()
      //       URL.revokeObjectURL(aLink.href)
      //       document.body.removeChild(aLink)
      //     } else {
      //       navigator.msSaveBlob(blob, that.showFileName)
      //     }
      //   }
      // }
    }
  }
}
</script>

<style lang="less" scoped>
  .MhPdfViewer{
    float: left;
  }
  .btnPreDiv{
    border: #0a84ff 0px solid;
  }
  .titleDiv {
    font-size: 11px;
    color: dodgerblue;
    border: 0px solid red;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align:center;
  }
  #xlsxViewer {
    overflow: auto;
  }
</style>
